import React from 'react'
import Header from '../../common/Header'
import CommonHeroSection from '../../common/CommonHeroSection'
import CommonBreadcrumb from '../../common/CommonBreadcrumb'
import DynamicTourSection from '../../sections/CommonSection/DynamicToureSection'
import Footer from '../../common/Footer'
import { pondicherryMahabalipuramData } from './tourPackageData'

function PondicherryMahabalipuram() {
    return (
        <>
            <Header />
            <CommonHeroSection title="Pondicherry Mahabalipuram" />
            <CommonBreadcrumb items={["Pondicherry Mahabalipuram"]} />
            <DynamicTourSection {...pondicherryMahabalipuramData} />
            <Footer />
        </>
    )
}

export default PondicherryMahabalipuram